import get from 'lodash/get'
import BaseImageImporter from './BaseImageImporter'

export default class CupraImageImporter extends BaseImageImporter {
  constructor() {
    super('cupra')
  }

  import(configuration) {
    return get(configuration, 'configuration.images', []).map(media => this.mapMedia(media))
  }

  mapMedia(media) {
    const matches = media.path.match(/-(\d+)\.jpg/)
    const suffix = (matches !== null ? matches[1] : '')

    return {
      origin: this.id,
      path: media.path,
      name: `Fahrzeugbild${suffix}`,
      mime: 'image/jpeg',
      base64: media.base64
    }
  }
}
